"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Image = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
var _constants2 = require("../DetailItem/constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  gridColumn: '1 / 2',
  gridRow: '1 / 2',
  display: 'grid',
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: _constants.LARGE_COMPONENT_RADIUS,
  [theme.breakpoints.between('sm', 'lg')]: {
    maxWidth: _constants2.DETAIL_ITEM_MOBILE_MAX_WIDTH,
    maxHeight: _constants2.DETAIL_ITEM_MOBILE_MAX_HEIGHT
  },
  [theme.breakpoints.up('lg')]: {
    borderRadius: `${_constants.LARGE_COMPONENT_RADIUS} 0 0 ${_constants.LARGE_COMPONENT_RADIUS}`
  },
  '&::before': {
    content: '""',
    display: 'block',
    zIndex: 2,
    gridArea: '1 / 1 / 2 / 2',
    width: '100%',
    paddingTop: '100%'
  }
}));
const Image = exports.Image = (0, _mui.styled)('img')({
  display: 'block',
  zIndex: 1,
  gridArea: '1 / 1 / 2 / 2',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: '50% 50%',
  borderRadius: `${_constants.LARGE_COMPONENT_RADIUS} 0 0 ${_constants.LARGE_COMPONENT_RADIUS}`
});
